import { createFileRoute } from "@tanstack/react-router";
import { Topbar } from "@/components/calv/Topbar";
import { Footer } from "@/components/calv/Footer";
import { Hero } from "@/components/calv/Hero";
import { Section } from "@/components/calv/Section";
import { LighthouseChecker } from "@/components/calv/LighthouseChecker";
import { SITE_URL } from "@/lib/locale";

const TITLE = "Lighthouse-Live-Check — Calvarius";
const DESC =
  "Sofortiges Lighthouse-Audit für beliebige URLs: Performance, Barrierefreiheit, Best Practices, SEO und Core Web Vitals — plus Top-3 Verbesserungs-Hebel.";
const URL_ = `${SITE_URL}/tools/lighthouse-check`;
const ALT = `${SITE_URL}/en/tools/lighthouse-check`;

export const Route = createFileRoute("/tools/lighthouse-check")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL_ },
      { property: "og:locale", content: "de_DE" },
      { property: "og:locale:alternate", content: "en_US" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESC },
    ],
    links: [
      { rel: "canonical", href: URL_ },
      { rel: "alternate", hrefLang: "de", href: URL_ },
      { rel: "alternate", hrefLang: "en", href: ALT },
      { rel: "alternate", hrefLang: "x-default", href: URL_ },
    ],
  }),
  component: LighthouseCheckDE,
});

function LighthouseCheckDE() {
  return (
    <>
      <Topbar />
      <main id="main">
        <Hero
          variant="short"
          number="01"
          eyebrow="Tool"
          headline={<>Lighthouse-Live-Check — <em>jede URL, sofort.</em></>}
          lead="Echtes Google-PageSpeed-Insights-Audit für beliebige Seiten. Vier Lighthouse-Scores, Core Web Vitals, Top-3 Verbesserungs-Hebel. In rund 30 Sekunden."
          metaStrip={["Google PageSpeed API", "Mobile · simuliertes 4G", "Drei Audits / 24 h"]}
          breadcrumbs={[{ label: "Start", to: "/" }, { label: "Tools", to: "/tools" }, { label: "Lighthouse-Check" }]}
        />

        <Section number="02" kicker="Audit" headline={<>URL eingeben. <em>Audit starten.</em></>} variant="tinted">
          <LighthouseChecker locale="de" />
        </Section>
      </main>
      <Footer />
    </>
  );
}
